import IRechargeLayer from "./IRechargeLayer";
import CommonToggleContainer from "../../Common/CommonToggleContainer";
import UIManager from "../../Shared/UIManager";
import ToggleItem from "../../Common/ToggleItem";
import NetworkLogic from "../../Shared/NetworkLogic";
import RechargeInfoUI from "./RechargeInfoUI";
import { Global } from "../../Shared/Global";
import Utils from "../../Shared/Utils";
import Player from "../../Models/Player";

const {ccclass, property} = cc._decorator;

@ccclass
export default class RechargeCodeLayer extends IRechargeLayer {
    @property(cc.Node)
    nodeTemplateFlag: cc.Node = null

    @property(cc.Prefab)
    pfbRechargeInfoLayer: cc.Prefab = null

    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null
    
    @property(CommonToggleContainer)
    toggleMoneyContainer: CommonToggleContainer = null

    @property(cc.Sprite)
    spCode: cc.Sprite = null

    @property(cc.Node)
    nodeClear: cc.Node = null

    @property(cc.EditBox)
    ebMoney: cc.EditBox = null

    @property(cc.EditBox)
    ebRealName: cc.EditBox = null

    @property(cc.EditBox)
    ebAccountName: cc.EditBox = null

    @property(cc.Label)
    lbMoney: cc.Label = null
    
    @property(cc.Label)
    lbRemark: cc.Label = null

    @property(cc.ScrollView)
    svLayer: cc.ScrollView = null

    private _decimal: number = 0

    start () {
        NetworkLogic.getRandomDecimal(function (data) {
            this._decimal = parseFloat(data)
        }.bind(this))
    }

    onEnable () {
        this.checkPlateform()
    }

    onDisable () {
        this.toggleContainer.clear()
        this.svLayer.scrollToTop()
    }
    
    protected refreshData () {
        this.configs.forEach(cfg => {
            let toggle = this.toggleContainer.addDefaultToggle(cfg.clientChannelName.replace("/", "\n"), cfg)
            if (cfg.offerPercentage > 0) {
                let nodeFlag = cc.instantiate(this.nodeTemplateFlag)
                nodeFlag.position = cc.v2(toggle.node.width / 2 - 20, toggle.node.height / 2 - 5)
                nodeFlag.parent = toggle.node
                nodeFlag.getChildByName("num").getComponent(cc.Label).string = "赠" + cfg.offerPercentage + "%"
            }
        });
    }

    onBtnClick (event, userData) {
        if (userData === "clear") {
            this.ebMoney.string = ""
        }else if (userData === "recharge") {
            // 需要补全资料
            if (Player.getPy("visitorFillInfoTime").indexOf("3") !== -1 && Player.getPy("userType") === 2) {
                // 打开界面
                let hallUI = cc.find("Canvas/gameNode") && cc.find("Canvas/gameNode").getComponent("HallUI");
                hallUI.openChildUI(hallUI.pfbLoginCompleteInformation);
                return
            }
            
            let money = this.ebMoney.node.active ? this.ebMoney.string : this.lbMoney.string

            if (this.checkMoney(money)) {
                if (this.ebRealName.string === "") {
                    UIManager.showToastUI("支付凭证不能为空", Global.ToastType.Warnning)
                    if (this.svLayer.node.convertToNodeSpaceAR(this.ebRealName.node.convertToWorldSpaceAR(cc.v2(0, 0))).y < -this.svLayer.node.height) {
                        this.svLayer.scrollToBottom(0.2)
                    }
                    return
                }

                let config = this.toggleContainer.checkedToggle.getComponent(ToggleItem).userData
                UIManager.showLoadingUI()
                NetworkLogic.chargeByUnderLineSolidcode({       
                    "chargeMoney": money,
                    "chargeTypeId": this.parentConfig["chargeTypeId"],
                    "id": config["id"],
                    "remark": this.ebAccountName.string,
                    "userCardNo": this.ebRealName.string
                }, function (data) {
                    UIManager.hideLoadingUI()
                    this.ebMoney.string = ""
                    this.ebRealName.string = ""
                    this.ebAccountName.string = ""
                    let rechargeInfoUI = cc.instantiate(this.pfbRechargeInfoLayer).getComponent(RechargeInfoUI)
                    rechargeInfoUI.node.parent = cc.find("Canvas")
                    rechargeInfoUI.money = data.money
                    rechargeInfoUI.order = data.orderNumber
                    rechargeInfoUI.date = data.createTime
                    rechargeInfoUI.type = data.type
                    rechargeInfoUI.state = data.status
                }.bind(this))
            }else {
                if (this.svLayer.node.convertToNodeSpaceAR(this.ebMoney.node.convertToWorldSpaceAR(cc.v2(0, 0))).y < -this.svLayer.node.height) {
                    this.svLayer.scrollToBottom(0.2)
                }
            }
        }else if (userData === "saveCode") {
            if (this.spCode.spriteFrame) {
                Utils.saveUrlImageToAlbum(this.spCode.spriteFrame.getTexture().url, "recharge_code_img.png", function (success) {
                    if (success) {
                        UIManager.showToastUI("保存图片成功", Global.ToastType.OK)
                    }else {
                        UIManager.showTipUI("保存图片失败。请前往手机设置页面，打开本应用存储图片的权限")
                    }
                }.bind(this))
            }else {
                UIManager.showToastUI("图片正在加载...", Global.ToastType.Warnning)
            }
        }
    }

    onSelectToggle (toggle, userData) {
        if (userData === "type") {
            this.reset()
            this.ebRealName.placeholder = toggle.userData.mustFillItem

            cc.loader.load({url: toggle.userData.qrCode, type: "png"}, function (err, texture) {
                if (!err && this.node) {
                    this.spCode.spriteFrame = new cc.SpriteFrame(texture)
                }
            }.bind(this))
            
            // 是否可以输入金额（0是1否）
            if (toggle.userData.isopenMonyInput === 0) { 
                this.nodeClear.active = true
                this.ebMoney.node.active = true
                this.lbMoney.node.active = false
                this.ebMoney.placeholder = "请输入" + toggle.userData.limitRangeDown + "~" + toggle.userData.limitRangeUp + "之间的金额"
            }else {
                this.nodeClear.active = false
                this.ebMoney.node.active = false
                this.lbMoney.node.active = true
            }
            
            // 配置金额
            let fixedAmount = JSON.parse(toggle.userData.fixedAmount)
            fixedAmount.forEach(item => {
                this.toggleMoneyContainer.addDefaultToggle("￥" + item.QuickSelectionAmount, item)
            })
            
            // 提示信息
            this.lbRemark.string = toggle.userData.remark
        }else if (userData === "money") {
            // 是否打开小数点（0是1否）
            let decimal = this.toggleContainer.checkedToggle.userData["isopenDecimalPoint"] === 0 ? this._decimal : 0

            // 是否可以重复选择（0是1否）
            if (this.toggleContainer.checkedToggle.userData["isopenRepeatInput"] === 0) {
                this.lbMoney.string = (this.lbMoney.string ? parseInt(this.lbMoney.string) : 0) + toggle.userData.QuickSelectionAmount + decimal
                this.ebMoney.string = (this.ebMoney.string ? parseInt(this.ebMoney.string) : 0) + toggle.userData.QuickSelectionAmount + decimal
            }else {
                this.lbMoney.string = toggle.userData.QuickSelectionAmount + decimal
                this.ebMoney.string = toggle.userData.QuickSelectionAmount + decimal
            }
        }
    }

    private reset () {
        this.toggleMoneyContainer.clear()
        this.spCode.spriteFrame = null
        this.ebMoney.string = ""
        this.ebRealName.string = ""
        this.ebAccountName.string = ""
        this.lbMoney.string = ""
    }

    // 区分支付宝、微信
    private checkPlateform () {
        if (!this.parentConfig) {
            return
        }
    }
}
